import { default as billingCbNuPITU8qMeta } from "/app/pages/admin/billing.vue?macro=true";
import { default as care_45teams61M56aDdTlMeta } from "/app/pages/admin/care-teams.vue?macro=true";
import { default as indexsPfPifH2baMeta } from "/app/pages/admin/devices/index.vue?macro=true";
import { default as organizationsa0RCfHT1MfMeta } from "/app/pages/admin/organizations.vue?macro=true";
import { default as practitioners8jIIFJS8TJMeta } from "/app/pages/admin/practitioners.vue?macro=true";
import { default as indexyb4TJ6mtnVMeta } from "/app/pages/admin/surveys/analytics/index.vue?macro=true";
import { default as _91id_93DybixVYPXbMeta } from "/app/pages/admin/surveys/models/[id].vue?macro=true";
import { default as indexHLvPJPgI7TMeta } from "/app/pages/admin/surveys/models/index.vue?macro=true";
import { default as france_45connect_45loginSXucvIOVRQMeta } from "/app/pages/auth/france-connect-login.vue?macro=true";
import { default as loginikXFF2hTKwMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as psc_45loginfTubREF9hMMeta } from "/app/pages/auth/psc-login.vue?macro=true";
import { default as psc2Ef8FoQd6nMeta } from "/app/pages/auth/psc.vue?macro=true";
import { default as externalXeZOkLZuJQMeta } from "/app/pages/call/external.vue?macro=true";
import { default as internalnDZsg4eA7HMeta } from "/app/pages/call/internal.vue?macro=true";
import { default as change_45password7PIohW8GYDMeta } from "/app/pages/change-password.vue?macro=true";
import { default as patienttr8vTXA9xOMeta } from "/app/pages/create/patient.vue?macro=true";
import { default as createyuywxUUkQlMeta } from "/app/pages/create.vue?macro=true";
import { default as patientjgBavmU68JMeta } from "/app/pages/demande/patient.vue?macro=true";
import { default as proP11M6loQ8dMeta } from "/app/pages/demande/pro.vue?macro=true";
import { default as procheyiypolnbV6Meta } from "/app/pages/demande/proche.vue?macro=true";
import { default as emergency_45loginnJekG82j4LMeta } from "/app/pages/emergency-login.vue?macro=true";
import { default as _91id_93JMuJERghpBMeta } from "/app/pages/encounters/[id].vue?macro=true";
import { default as helperNKCeA9UlM6Meta } from "/app/pages/encounters/helper.ts?macro=true";
import { default as forget_45passwordEVWK44q6hlMeta } from "/app/pages/forget-password.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as logoutHaVXWqg8UAMeta } from "/app/pages/logout.vue?macro=true";
import { default as index3j3QFMJtPdMeta } from "/app/pages/map/[patientId]/index.vue?macro=true";
import { default as map8NxtI69oDxMeta } from "/app/pages/map.vue?macro=true";
import { default as mobileo5w0kjkm6DMeta } from "/app/pages/mobile.vue?macro=true";
import { default as indexJuIO46yOZ1Meta } from "/app/pages/monitor/index.vue?macro=true";
import { default as examVXhcsM59D4Meta } from "/app/pages/patients/[patientId]/chart/exam.vue?macro=true";
import { default as exams0LA1IVFRIIMeta } from "/app/pages/patients/[patientId]/chart/exams.vue?macro=true";
import { default as indexrzoLiopPdiMeta } from "/app/pages/patients/[patientId]/chart/index.vue?macro=true";
import { default as monitoringUI05lY5cQMMeta } from "/app/pages/patients/[patientId]/chart/monitoring.vue?macro=true";
import { default as preview11jhGyoMdRMeta } from "/app/pages/patients/[patientId]/documents/[documentId]/preview.vue?macro=true";
import { default as surveyJO7y7yqJU7Meta } from "/app/pages/patients/[patientId]/documents/[documentId]/survey.vue?macro=true";
import { default as captureohjAeRkuCMMeta } from "/app/pages/patients/[patientId]/documents/capture.vue?macro=true";
import { default as indexMI7OMO2EtrMeta } from "/app/pages/patients/[patientId]/documents/index.vue?macro=true";
import { default as indexCaDIBLuUGkMeta } from "/app/pages/patients/[patientId]/equipments/index.vue?macro=true";
import { default as scann7WQVlvsGhMeta } from "/app/pages/patients/[patientId]/equipments/scan.vue?macro=true";
import { default as synchronisationycOk4bmNi2Meta } from "/app/pages/patients/[patientId]/equipments/synchronisation.vue?macro=true";
import { default as examN1uPpRMLXXMeta } from "/app/pages/patients/[patientId]/exam.vue?macro=true";
import { default as indexJLuWX5to5TMeta } from "/app/pages/patients/[patientId]/followup/encounter/[id]/index.vue?macro=true";
import { default as indexiIUUm48BBsMeta } from "/app/pages/patients/[patientId]/followup/index.vue?macro=true";
import { default as indexd8MeWmPfuGMeta } from "/app/pages/patients/[patientId]/index.vue?macro=true";
import { default as editRNj2Vz6ykIMeta } from "/app/pages/patients/[patientId]/network/[organizationId]/edit.vue?macro=true";
import { default as editPersonfpK0r8APK8Meta } from "/app/pages/patients/[patientId]/network/[personId]/editPerson.vue?macro=true";
import { default as addOrganizationjKMC3P2agYMeta } from "/app/pages/patients/[patientId]/network/addOrganization.vue?macro=true";
import { default as addPersony6Lw5U5vm0Meta } from "/app/pages/patients/[patientId]/network/addPerson.vue?macro=true";
import { default as indexjagbdzGAyvMeta } from "/app/pages/patients/[patientId]/network/index.vue?macro=true";
import { default as patient7QjVTEFQRMMeta } from "/app/pages/patients/[patientId]/network/patient.vue?macro=true";
import { default as personalYTzbflfc9BMeta } from "/app/pages/patients/[patientId]/network/personal.vue?macro=true";
import { default as profesionnalM02JiMobKKMeta } from "/app/pages/patients/[patientId]/network/profesionnal.vue?macro=true";
import { default as searchOrganization9oIyX6SNZMMeta } from "/app/pages/patients/[patientId]/network/searchOrganization.vue?macro=true";
import { default as searchPersonhwrJCZR0x3Meta } from "/app/pages/patients/[patientId]/network/searchPerson.vue?macro=true";
import { default as indexMywwa101LIMeta } from "/app/pages/patients/[patientId]/planning/index.vue?macro=true";
import { default as monitoringmkB5aLenteMeta } from "/app/pages/patients/[patientId]/planning/monitoring.vue?macro=true";
import { default as plannedsurvey4a9XXnbOhyMeta } from "/app/pages/patients/[patientId]/planning/plannedsurvey.vue?macro=true";
import { default as indexRCe5QaKTfGMeta } from "/app/pages/patients/[patientId]/planning/tasks/index.vue?macro=true";
import { default as newjOcnUHDzh5Meta } from "/app/pages/patients/[patientId]/planning/tasks/new.vue?macro=true";
import { default as adminEMMP9JwI2TMeta } from "/app/pages/patients/[patientId]/record/admin.vue?macro=true";
import { default as contactTjvNQHXFFYMeta } from "/app/pages/patients/[patientId]/record/contact.vue?macro=true";
import { default as indexwcjNk9m8tXMeta } from "/app/pages/patients/[patientId]/record/eoc/[action]/index.vue?macro=true";
import { default as indexrnkvsVdJ8bMeta } from "/app/pages/patients/[patientId]/record/eoc/index.vue?macro=true";
import { default as termineraQA6eLHdtGMeta } from "/app/pages/patients/[patientId]/record/eoc/terminer.vue?macro=true";
import { default as identity06GHiwhdSsMeta } from "/app/pages/patients/[patientId]/record/identity.vue?macro=true";
import { default as index8ZHe1MRNM9Meta } from "/app/pages/patients/[patientId]/record/index.vue?macro=true";
import { default as livingPlacebtMq2Djr3WMeta } from "/app/pages/patients/[patientId]/record/livingPlace.vue?macro=true";
import { default as medicalLXLHSHT6RyMeta } from "/app/pages/patients/[patientId]/record/medical.vue?macro=true";
import { default as social8x4ArvKMcnMeta } from "/app/pages/patients/[patientId]/record/social.vue?macro=true";
import { default as wayOfLife04Ec4lvMTIMeta } from "/app/pages/patients/[patientId]/record/wayOfLife.vue?macro=true";
import { default as createKPhBz5qYo3Meta } from "/app/pages/patients/create.vue?macro=true";
import { default as identitypCcICwdfytMeta } from "/app/pages/patients/identity.vue?macro=true";
import { default as mapNY87TP1mSOMeta } from "/app/pages/patients/map.vue?macro=true";
import { default as patientsDDD0rjOkLkMeta } from "/app/pages/patients.vue?macro=true";
import { default as index7JpInv2z7FMeta } from "/app/pages/practitioners/[practitionerId]/index.vue?macro=true";
import { default as indexSZuZrNKLPjMeta } from "/app/pages/practitioners/[practitionerId]/planning/tasks/index.vue?macro=true";
import { default as practitioners8npiMKc0xeMeta } from "/app/pages/practitioners.vue?macro=true";
import { default as _91id_93i5GmLKr8rQMeta } from "/app/pages/report/[id].vue?macro=true";
import { default as reset_45password52TOS9kgCUMeta } from "/app/pages/reset-password.vue?macro=true";
import { default as patientsP2gYMLpH4pMeta } from "/app/pages/search/patients.vue?macro=true";
import { default as phonebookNPXp8TLycBMeta } from "/app/pages/search/phonebook.vue?macro=true";
import { default as practitionersTtp9lYcwoRMeta } from "/app/pages/search/practitioners.vue?macro=true";
import { default as searchfcnTL5fl5XMeta } from "/app/pages/search.vue?macro=true";
import { default as _91id_93v4tSkIo4uwMeta } from "/app/pages/survey/[id].vue?macro=true";
import { default as expiredKX7n0VYoDzMeta } from "/app/pages/survey/expired.vue?macro=true";
import { default as processPrescritionInfomo0RSFWfAPMeta } from "/app/pages/survey/processPrescritionInfo.ts?macro=true";
import { default as processSurveyAnswersHsDZDcogotMeta } from "/app/pages/survey/processSurveyAnswers.ts?macro=true";
import { default as seedSurveyAnswers1jAucYzcAGMeta } from "/app/pages/survey/seedSurveyAnswers.ts?macro=true";
export default [
  {
    name: billingCbNuPITU8qMeta?.name ?? "admin-billing",
    path: billingCbNuPITU8qMeta?.path ?? "/admin/billing",
    meta: billingCbNuPITU8qMeta || {},
    alias: billingCbNuPITU8qMeta?.alias || [],
    redirect: billingCbNuPITU8qMeta?.redirect,
    component: () => import("/app/pages/admin/billing.vue").then(m => m.default || m)
  },
  {
    name: care_45teams61M56aDdTlMeta?.name ?? "admin-care-teams",
    path: care_45teams61M56aDdTlMeta?.path ?? "/admin/care-teams",
    meta: care_45teams61M56aDdTlMeta || {},
    alias: care_45teams61M56aDdTlMeta?.alias || [],
    redirect: care_45teams61M56aDdTlMeta?.redirect,
    component: () => import("/app/pages/admin/care-teams.vue").then(m => m.default || m)
  },
  {
    name: indexsPfPifH2baMeta?.name ?? "admin-devices",
    path: indexsPfPifH2baMeta?.path ?? "/admin/devices",
    meta: indexsPfPifH2baMeta || {},
    alias: indexsPfPifH2baMeta?.alias || [],
    redirect: indexsPfPifH2baMeta?.redirect,
    component: () => import("/app/pages/admin/devices/index.vue").then(m => m.default || m)
  },
  {
    name: organizationsa0RCfHT1MfMeta?.name ?? "admin-organizations",
    path: organizationsa0RCfHT1MfMeta?.path ?? "/admin/organizations",
    meta: organizationsa0RCfHT1MfMeta || {},
    alias: organizationsa0RCfHT1MfMeta?.alias || [],
    redirect: organizationsa0RCfHT1MfMeta?.redirect,
    component: () => import("/app/pages/admin/organizations.vue").then(m => m.default || m)
  },
  {
    name: practitioners8jIIFJS8TJMeta?.name ?? "admin-practitioners",
    path: practitioners8jIIFJS8TJMeta?.path ?? "/admin/practitioners",
    meta: practitioners8jIIFJS8TJMeta || {},
    alias: practitioners8jIIFJS8TJMeta?.alias || [],
    redirect: practitioners8jIIFJS8TJMeta?.redirect,
    component: () => import("/app/pages/admin/practitioners.vue").then(m => m.default || m)
  },
  {
    name: indexyb4TJ6mtnVMeta?.name ?? "admin-surveys-analytics",
    path: indexyb4TJ6mtnVMeta?.path ?? "/admin/surveys/analytics",
    meta: indexyb4TJ6mtnVMeta || {},
    alias: indexyb4TJ6mtnVMeta?.alias || [],
    redirect: indexyb4TJ6mtnVMeta?.redirect,
    component: () => import("/app/pages/admin/surveys/analytics/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93DybixVYPXbMeta?.name ?? "admin-surveys-models-id",
    path: _91id_93DybixVYPXbMeta?.path ?? "/admin/surveys/models/:id()",
    meta: _91id_93DybixVYPXbMeta || {},
    alias: _91id_93DybixVYPXbMeta?.alias || [],
    redirect: _91id_93DybixVYPXbMeta?.redirect,
    component: () => import("/app/pages/admin/surveys/models/[id].vue").then(m => m.default || m)
  },
  {
    name: indexHLvPJPgI7TMeta?.name ?? "admin-surveys-models",
    path: indexHLvPJPgI7TMeta?.path ?? "/admin/surveys/models",
    meta: indexHLvPJPgI7TMeta || {},
    alias: indexHLvPJPgI7TMeta?.alias || [],
    redirect: indexHLvPJPgI7TMeta?.redirect,
    component: () => import("/app/pages/admin/surveys/models/index.vue").then(m => m.default || m)
  },
  {
    name: france_45connect_45loginSXucvIOVRQMeta?.name ?? "auth-france-connect-login",
    path: france_45connect_45loginSXucvIOVRQMeta?.path ?? "/auth/france-connect-login",
    meta: france_45connect_45loginSXucvIOVRQMeta || {},
    alias: france_45connect_45loginSXucvIOVRQMeta?.alias || [],
    redirect: france_45connect_45loginSXucvIOVRQMeta?.redirect,
    component: () => import("/app/pages/auth/france-connect-login.vue").then(m => m.default || m)
  },
  {
    name: loginikXFF2hTKwMeta?.name ?? "auth-login",
    path: loginikXFF2hTKwMeta?.path ?? "/auth/login",
    meta: loginikXFF2hTKwMeta || {},
    alias: loginikXFF2hTKwMeta?.alias || [],
    redirect: loginikXFF2hTKwMeta?.redirect,
    component: () => import("/app/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: psc_45loginfTubREF9hMMeta?.name ?? "auth-psc-login",
    path: psc_45loginfTubREF9hMMeta?.path ?? "/auth/psc-login",
    meta: psc_45loginfTubREF9hMMeta || {},
    alias: psc_45loginfTubREF9hMMeta?.alias || [],
    redirect: psc_45loginfTubREF9hMMeta?.redirect,
    component: () => import("/app/pages/auth/psc-login.vue").then(m => m.default || m)
  },
  {
    name: psc2Ef8FoQd6nMeta?.name ?? "auth-psc",
    path: psc2Ef8FoQd6nMeta?.path ?? "/auth/psc",
    meta: psc2Ef8FoQd6nMeta || {},
    alias: psc2Ef8FoQd6nMeta?.alias || [],
    redirect: psc2Ef8FoQd6nMeta?.redirect,
    component: () => import("/app/pages/auth/psc.vue").then(m => m.default || m)
  },
  {
    name: externalXeZOkLZuJQMeta?.name ?? "call-external",
    path: externalXeZOkLZuJQMeta?.path ?? "/call/external",
    meta: externalXeZOkLZuJQMeta || {},
    alias: externalXeZOkLZuJQMeta?.alias || [],
    redirect: externalXeZOkLZuJQMeta?.redirect,
    component: () => import("/app/pages/call/external.vue").then(m => m.default || m)
  },
  {
    name: internalnDZsg4eA7HMeta?.name ?? "call-internal",
    path: internalnDZsg4eA7HMeta?.path ?? "/call/internal",
    meta: internalnDZsg4eA7HMeta || {},
    alias: internalnDZsg4eA7HMeta?.alias || [],
    redirect: internalnDZsg4eA7HMeta?.redirect,
    component: () => import("/app/pages/call/internal.vue").then(m => m.default || m)
  },
  {
    name: change_45password7PIohW8GYDMeta?.name ?? "change-password",
    path: change_45password7PIohW8GYDMeta?.path ?? "/change-password",
    meta: change_45password7PIohW8GYDMeta || {},
    alias: change_45password7PIohW8GYDMeta?.alias || [],
    redirect: change_45password7PIohW8GYDMeta?.redirect,
    component: () => import("/app/pages/change-password.vue").then(m => m.default || m)
  },
  {
    name: createyuywxUUkQlMeta?.name ?? "create",
    path: createyuywxUUkQlMeta?.path ?? "/create",
    meta: createyuywxUUkQlMeta || {},
    alias: createyuywxUUkQlMeta?.alias || [],
    redirect: createyuywxUUkQlMeta?.redirect,
    component: () => import("/app/pages/create.vue").then(m => m.default || m),
    children: [
  {
    name: patienttr8vTXA9xOMeta?.name ?? "create-patient",
    path: patienttr8vTXA9xOMeta?.path ?? "patient",
    meta: patienttr8vTXA9xOMeta || {},
    alias: patienttr8vTXA9xOMeta?.alias || [],
    redirect: patienttr8vTXA9xOMeta?.redirect,
    component: () => import("/app/pages/create/patient.vue").then(m => m.default || m)
  }
]
  },
  {
    name: patientjgBavmU68JMeta?.name ?? "demande-patient",
    path: patientjgBavmU68JMeta?.path ?? "/demande/patient",
    meta: patientjgBavmU68JMeta || {},
    alias: patientjgBavmU68JMeta?.alias || [],
    redirect: patientjgBavmU68JMeta?.redirect,
    component: () => import("/app/pages/demande/patient.vue").then(m => m.default || m)
  },
  {
    name: proP11M6loQ8dMeta?.name ?? "demande-pro",
    path: proP11M6loQ8dMeta?.path ?? "/demande/pro",
    meta: proP11M6loQ8dMeta || {},
    alias: proP11M6loQ8dMeta?.alias || [],
    redirect: proP11M6loQ8dMeta?.redirect,
    component: () => import("/app/pages/demande/pro.vue").then(m => m.default || m)
  },
  {
    name: procheyiypolnbV6Meta?.name ?? "demande-proche",
    path: procheyiypolnbV6Meta?.path ?? "/demande/proche",
    meta: procheyiypolnbV6Meta || {},
    alias: procheyiypolnbV6Meta?.alias || [],
    redirect: procheyiypolnbV6Meta?.redirect,
    component: () => import("/app/pages/demande/proche.vue").then(m => m.default || m)
  },
  {
    name: emergency_45loginnJekG82j4LMeta?.name ?? "emergency-login",
    path: emergency_45loginnJekG82j4LMeta?.path ?? "/emergency-login",
    meta: emergency_45loginnJekG82j4LMeta || {},
    alias: emergency_45loginnJekG82j4LMeta?.alias || [],
    redirect: emergency_45loginnJekG82j4LMeta?.redirect,
    component: () => import("/app/pages/emergency-login.vue").then(m => m.default || m)
  },
  {
    name: _91id_93JMuJERghpBMeta?.name ?? "encounters-id",
    path: _91id_93JMuJERghpBMeta?.path ?? "/encounters/:id()",
    meta: _91id_93JMuJERghpBMeta || {},
    alias: _91id_93JMuJERghpBMeta?.alias || [],
    redirect: _91id_93JMuJERghpBMeta?.redirect,
    component: () => import("/app/pages/encounters/[id].vue").then(m => m.default || m)
  },
  {
    name: helperNKCeA9UlM6Meta?.name ?? "encounters-helper",
    path: helperNKCeA9UlM6Meta?.path ?? "/encounters/helper",
    meta: helperNKCeA9UlM6Meta || {},
    alias: helperNKCeA9UlM6Meta?.alias || [],
    redirect: helperNKCeA9UlM6Meta?.redirect,
    component: () => import("/app/pages/encounters/helper.ts").then(m => m.default || m)
  },
  {
    name: forget_45passwordEVWK44q6hlMeta?.name ?? "forget-password",
    path: forget_45passwordEVWK44q6hlMeta?.path ?? "/forget-password",
    meta: forget_45passwordEVWK44q6hlMeta || {},
    alias: forget_45passwordEVWK44q6hlMeta?.alias || [],
    redirect: forget_45passwordEVWK44q6hlMeta?.redirect,
    component: () => import("/app/pages/forget-password.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: logoutHaVXWqg8UAMeta?.name ?? "logout",
    path: logoutHaVXWqg8UAMeta?.path ?? "/logout",
    meta: logoutHaVXWqg8UAMeta || {},
    alias: logoutHaVXWqg8UAMeta?.alias || [],
    redirect: logoutHaVXWqg8UAMeta?.redirect,
    component: () => import("/app/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: map8NxtI69oDxMeta?.name ?? "map",
    path: map8NxtI69oDxMeta?.path ?? "/map",
    meta: map8NxtI69oDxMeta || {},
    alias: map8NxtI69oDxMeta?.alias || [],
    redirect: map8NxtI69oDxMeta?.redirect,
    component: () => import("/app/pages/map.vue").then(m => m.default || m),
    children: [
  {
    name: index3j3QFMJtPdMeta?.name ?? "map-patientId",
    path: index3j3QFMJtPdMeta?.path ?? ":patientId()",
    meta: index3j3QFMJtPdMeta || {},
    alias: index3j3QFMJtPdMeta?.alias || [],
    redirect: index3j3QFMJtPdMeta?.redirect,
    component: () => import("/app/pages/map/[patientId]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: mobileo5w0kjkm6DMeta?.name ?? "mobile",
    path: mobileo5w0kjkm6DMeta?.path ?? "/mobile",
    meta: mobileo5w0kjkm6DMeta || {},
    alias: mobileo5w0kjkm6DMeta?.alias || [],
    redirect: mobileo5w0kjkm6DMeta?.redirect,
    component: () => import("/app/pages/mobile.vue").then(m => m.default || m)
  },
  {
    name: indexJuIO46yOZ1Meta?.name ?? "monitor",
    path: indexJuIO46yOZ1Meta?.path ?? "/monitor",
    meta: indexJuIO46yOZ1Meta || {},
    alias: indexJuIO46yOZ1Meta?.alias || [],
    redirect: indexJuIO46yOZ1Meta?.redirect,
    component: () => import("/app/pages/monitor/index.vue").then(m => m.default || m)
  },
  {
    name: patientsDDD0rjOkLkMeta?.name ?? "patients",
    path: patientsDDD0rjOkLkMeta?.path ?? "/patients",
    meta: patientsDDD0rjOkLkMeta || {},
    alias: patientsDDD0rjOkLkMeta?.alias || [],
    redirect: patientsDDD0rjOkLkMeta?.redirect,
    component: () => import("/app/pages/patients.vue").then(m => m.default || m),
    children: [
  {
    name: examVXhcsM59D4Meta?.name ?? "patients-patientId-chart-exam",
    path: examVXhcsM59D4Meta?.path ?? ":patientId()/chart/exam",
    meta: examVXhcsM59D4Meta || {},
    alias: examVXhcsM59D4Meta?.alias || [],
    redirect: examVXhcsM59D4Meta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/chart/exam.vue").then(m => m.default || m)
  },
  {
    name: exams0LA1IVFRIIMeta?.name ?? "patients-patientId-chart-exams",
    path: exams0LA1IVFRIIMeta?.path ?? ":patientId()/chart/exams",
    meta: exams0LA1IVFRIIMeta || {},
    alias: exams0LA1IVFRIIMeta?.alias || [],
    redirect: exams0LA1IVFRIIMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/chart/exams.vue").then(m => m.default || m)
  },
  {
    name: indexrzoLiopPdiMeta?.name ?? "patients-patientId-chart",
    path: indexrzoLiopPdiMeta?.path ?? ":patientId()/chart",
    meta: indexrzoLiopPdiMeta || {},
    alias: indexrzoLiopPdiMeta?.alias || [],
    redirect: indexrzoLiopPdiMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/chart/index.vue").then(m => m.default || m)
  },
  {
    name: monitoringUI05lY5cQMMeta?.name ?? "patients-patientId-chart-monitoring",
    path: monitoringUI05lY5cQMMeta?.path ?? ":patientId()/chart/monitoring",
    meta: monitoringUI05lY5cQMMeta || {},
    alias: monitoringUI05lY5cQMMeta?.alias || [],
    redirect: monitoringUI05lY5cQMMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/chart/monitoring.vue").then(m => m.default || m)
  },
  {
    name: preview11jhGyoMdRMeta?.name ?? "patients-patientId-documents-documentId-preview",
    path: preview11jhGyoMdRMeta?.path ?? ":patientId()/documents/:documentId()/preview",
    meta: preview11jhGyoMdRMeta || {},
    alias: preview11jhGyoMdRMeta?.alias || [],
    redirect: preview11jhGyoMdRMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/documents/[documentId]/preview.vue").then(m => m.default || m)
  },
  {
    name: surveyJO7y7yqJU7Meta?.name ?? "patients-patientId-documents-documentId-survey",
    path: surveyJO7y7yqJU7Meta?.path ?? ":patientId()/documents/:documentId()/survey",
    meta: surveyJO7y7yqJU7Meta || {},
    alias: surveyJO7y7yqJU7Meta?.alias || [],
    redirect: surveyJO7y7yqJU7Meta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/documents/[documentId]/survey.vue").then(m => m.default || m)
  },
  {
    name: captureohjAeRkuCMMeta?.name ?? "patients-patientId-documents-capture",
    path: captureohjAeRkuCMMeta?.path ?? ":patientId()/documents/capture",
    meta: captureohjAeRkuCMMeta || {},
    alias: captureohjAeRkuCMMeta?.alias || [],
    redirect: captureohjAeRkuCMMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/documents/capture.vue").then(m => m.default || m)
  },
  {
    name: indexMI7OMO2EtrMeta?.name ?? "patients-patientId-documents",
    path: indexMI7OMO2EtrMeta?.path ?? ":patientId()/documents",
    meta: indexMI7OMO2EtrMeta || {},
    alias: indexMI7OMO2EtrMeta?.alias || [],
    redirect: indexMI7OMO2EtrMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/documents/index.vue").then(m => m.default || m)
  },
  {
    name: indexCaDIBLuUGkMeta?.name ?? "patients-patientId-equipments",
    path: indexCaDIBLuUGkMeta?.path ?? ":patientId()/equipments",
    meta: indexCaDIBLuUGkMeta || {},
    alias: indexCaDIBLuUGkMeta?.alias || [],
    redirect: indexCaDIBLuUGkMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/equipments/index.vue").then(m => m.default || m)
  },
  {
    name: scann7WQVlvsGhMeta?.name ?? "patients-patientId-equipments-scan",
    path: scann7WQVlvsGhMeta?.path ?? ":patientId()/equipments/scan",
    meta: scann7WQVlvsGhMeta || {},
    alias: scann7WQVlvsGhMeta?.alias || [],
    redirect: scann7WQVlvsGhMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/equipments/scan.vue").then(m => m.default || m)
  },
  {
    name: synchronisationycOk4bmNi2Meta?.name ?? "patients-patientId-equipments-synchronisation",
    path: synchronisationycOk4bmNi2Meta?.path ?? ":patientId()/equipments/synchronisation",
    meta: synchronisationycOk4bmNi2Meta || {},
    alias: synchronisationycOk4bmNi2Meta?.alias || [],
    redirect: synchronisationycOk4bmNi2Meta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/equipments/synchronisation.vue").then(m => m.default || m)
  },
  {
    name: examN1uPpRMLXXMeta?.name ?? "patients-patientId-exam",
    path: examN1uPpRMLXXMeta?.path ?? ":patientId()/exam",
    meta: examN1uPpRMLXXMeta || {},
    alias: examN1uPpRMLXXMeta?.alias || [],
    redirect: examN1uPpRMLXXMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/exam.vue").then(m => m.default || m)
  },
  {
    name: indexJLuWX5to5TMeta?.name ?? "patients-patientId-followup-encounter-id",
    path: indexJLuWX5to5TMeta?.path ?? ":patientId()/followup/encounter/:id()",
    meta: indexJLuWX5to5TMeta || {},
    alias: indexJLuWX5to5TMeta?.alias || [],
    redirect: indexJLuWX5to5TMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/followup/encounter/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexiIUUm48BBsMeta?.name ?? "patients-patientId-followup",
    path: indexiIUUm48BBsMeta?.path ?? ":patientId()/followup",
    meta: indexiIUUm48BBsMeta || {},
    alias: indexiIUUm48BBsMeta?.alias || [],
    redirect: indexiIUUm48BBsMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/followup/index.vue").then(m => m.default || m)
  },
  {
    name: indexd8MeWmPfuGMeta?.name ?? "patients-patientId",
    path: indexd8MeWmPfuGMeta?.path ?? ":patientId()",
    meta: indexd8MeWmPfuGMeta || {},
    alias: indexd8MeWmPfuGMeta?.alias || [],
    redirect: indexd8MeWmPfuGMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/index.vue").then(m => m.default || m)
  },
  {
    name: editRNj2Vz6ykIMeta?.name ?? "patients-patientId-network-organizationId-edit",
    path: editRNj2Vz6ykIMeta?.path ?? ":patientId()/network/:organizationId()/edit",
    meta: editRNj2Vz6ykIMeta || {},
    alias: editRNj2Vz6ykIMeta?.alias || [],
    redirect: editRNj2Vz6ykIMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/[organizationId]/edit.vue").then(m => m.default || m)
  },
  {
    name: editPersonfpK0r8APK8Meta?.name ?? "patients-patientId-network-personId-editPerson",
    path: editPersonfpK0r8APK8Meta?.path ?? ":patientId()/network/:personId()/editPerson",
    meta: editPersonfpK0r8APK8Meta || {},
    alias: editPersonfpK0r8APK8Meta?.alias || [],
    redirect: editPersonfpK0r8APK8Meta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/[personId]/editPerson.vue").then(m => m.default || m)
  },
  {
    name: addOrganizationjKMC3P2agYMeta?.name ?? "patients-patientId-network-addOrganization",
    path: addOrganizationjKMC3P2agYMeta?.path ?? ":patientId()/network/addOrganization",
    meta: addOrganizationjKMC3P2agYMeta || {},
    alias: addOrganizationjKMC3P2agYMeta?.alias || [],
    redirect: addOrganizationjKMC3P2agYMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/addOrganization.vue").then(m => m.default || m)
  },
  {
    name: addPersony6Lw5U5vm0Meta?.name ?? "patients-patientId-network-addPerson",
    path: addPersony6Lw5U5vm0Meta?.path ?? ":patientId()/network/addPerson",
    meta: addPersony6Lw5U5vm0Meta || {},
    alias: addPersony6Lw5U5vm0Meta?.alias || [],
    redirect: addPersony6Lw5U5vm0Meta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/addPerson.vue").then(m => m.default || m)
  },
  {
    name: indexjagbdzGAyvMeta?.name ?? "patients-patientId-network",
    path: indexjagbdzGAyvMeta?.path ?? ":patientId()/network",
    meta: indexjagbdzGAyvMeta || {},
    alias: indexjagbdzGAyvMeta?.alias || [],
    redirect: indexjagbdzGAyvMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/index.vue").then(m => m.default || m)
  },
  {
    name: patient7QjVTEFQRMMeta?.name ?? "patients-patientId-network-patient",
    path: patient7QjVTEFQRMMeta?.path ?? ":patientId()/network/patient",
    meta: patient7QjVTEFQRMMeta || {},
    alias: patient7QjVTEFQRMMeta?.alias || [],
    redirect: patient7QjVTEFQRMMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/patient.vue").then(m => m.default || m)
  },
  {
    name: personalYTzbflfc9BMeta?.name ?? "patients-patientId-network-personal",
    path: personalYTzbflfc9BMeta?.path ?? ":patientId()/network/personal",
    meta: personalYTzbflfc9BMeta || {},
    alias: personalYTzbflfc9BMeta?.alias || [],
    redirect: personalYTzbflfc9BMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/personal.vue").then(m => m.default || m)
  },
  {
    name: profesionnalM02JiMobKKMeta?.name ?? "patients-patientId-network-profesionnal",
    path: profesionnalM02JiMobKKMeta?.path ?? ":patientId()/network/profesionnal",
    meta: profesionnalM02JiMobKKMeta || {},
    alias: profesionnalM02JiMobKKMeta?.alias || [],
    redirect: profesionnalM02JiMobKKMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/profesionnal.vue").then(m => m.default || m)
  },
  {
    name: searchOrganization9oIyX6SNZMMeta?.name ?? "patients-patientId-network-searchOrganization",
    path: searchOrganization9oIyX6SNZMMeta?.path ?? ":patientId()/network/searchOrganization",
    meta: searchOrganization9oIyX6SNZMMeta || {},
    alias: searchOrganization9oIyX6SNZMMeta?.alias || [],
    redirect: searchOrganization9oIyX6SNZMMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/searchOrganization.vue").then(m => m.default || m)
  },
  {
    name: searchPersonhwrJCZR0x3Meta?.name ?? "patients-patientId-network-searchPerson",
    path: searchPersonhwrJCZR0x3Meta?.path ?? ":patientId()/network/searchPerson",
    meta: searchPersonhwrJCZR0x3Meta || {},
    alias: searchPersonhwrJCZR0x3Meta?.alias || [],
    redirect: searchPersonhwrJCZR0x3Meta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/network/searchPerson.vue").then(m => m.default || m)
  },
  {
    name: indexMywwa101LIMeta?.name ?? "patients-patientId-planning",
    path: indexMywwa101LIMeta?.path ?? ":patientId()/planning",
    meta: indexMywwa101LIMeta || {},
    alias: indexMywwa101LIMeta?.alias || [],
    redirect: indexMywwa101LIMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/planning/index.vue").then(m => m.default || m)
  },
  {
    name: monitoringmkB5aLenteMeta?.name ?? "patients-patientId-planning-monitoring",
    path: monitoringmkB5aLenteMeta?.path ?? ":patientId()/planning/monitoring",
    meta: monitoringmkB5aLenteMeta || {},
    alias: monitoringmkB5aLenteMeta?.alias || [],
    redirect: monitoringmkB5aLenteMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/planning/monitoring.vue").then(m => m.default || m)
  },
  {
    name: plannedsurvey4a9XXnbOhyMeta?.name ?? "patients-patientId-planning-plannedsurvey",
    path: plannedsurvey4a9XXnbOhyMeta?.path ?? ":patientId()/planning/plannedsurvey",
    meta: plannedsurvey4a9XXnbOhyMeta || {},
    alias: plannedsurvey4a9XXnbOhyMeta?.alias || [],
    redirect: plannedsurvey4a9XXnbOhyMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/planning/plannedsurvey.vue").then(m => m.default || m)
  },
  {
    name: indexRCe5QaKTfGMeta?.name ?? "patients-patientId-planning-tasks",
    path: indexRCe5QaKTfGMeta?.path ?? ":patientId()/planning/tasks",
    meta: indexRCe5QaKTfGMeta || {},
    alias: indexRCe5QaKTfGMeta?.alias || [],
    redirect: indexRCe5QaKTfGMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/planning/tasks/index.vue").then(m => m.default || m)
  },
  {
    name: newjOcnUHDzh5Meta?.name ?? "patients-patientId-planning-tasks-new",
    path: newjOcnUHDzh5Meta?.path ?? ":patientId()/planning/tasks/new",
    meta: newjOcnUHDzh5Meta || {},
    alias: newjOcnUHDzh5Meta?.alias || [],
    redirect: newjOcnUHDzh5Meta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/planning/tasks/new.vue").then(m => m.default || m)
  },
  {
    name: adminEMMP9JwI2TMeta?.name ?? "patients-patientId-record-admin",
    path: adminEMMP9JwI2TMeta?.path ?? ":patientId()/record/admin",
    meta: adminEMMP9JwI2TMeta || {},
    alias: adminEMMP9JwI2TMeta?.alias || [],
    redirect: adminEMMP9JwI2TMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/admin.vue").then(m => m.default || m)
  },
  {
    name: contactTjvNQHXFFYMeta?.name ?? "patients-patientId-record-contact",
    path: contactTjvNQHXFFYMeta?.path ?? ":patientId()/record/contact",
    meta: contactTjvNQHXFFYMeta || {},
    alias: contactTjvNQHXFFYMeta?.alias || [],
    redirect: contactTjvNQHXFFYMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/contact.vue").then(m => m.default || m)
  },
  {
    name: indexwcjNk9m8tXMeta?.name ?? "patients-patientId-record-eoc-action",
    path: indexwcjNk9m8tXMeta?.path ?? ":patientId()/record/eoc/:action()",
    meta: indexwcjNk9m8tXMeta || {},
    alias: indexwcjNk9m8tXMeta?.alias || [],
    redirect: indexwcjNk9m8tXMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/eoc/[action]/index.vue").then(m => m.default || m)
  },
  {
    name: indexrnkvsVdJ8bMeta?.name ?? "patients-patientId-record-eoc",
    path: indexrnkvsVdJ8bMeta?.path ?? ":patientId()/record/eoc",
    meta: indexrnkvsVdJ8bMeta || {},
    alias: indexrnkvsVdJ8bMeta?.alias || [],
    redirect: indexrnkvsVdJ8bMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/eoc/index.vue").then(m => m.default || m)
  },
  {
    name: termineraQA6eLHdtGMeta?.name ?? "patients-patientId-record-eoc-terminer",
    path: termineraQA6eLHdtGMeta?.path ?? ":patientId()/record/eoc/terminer",
    meta: termineraQA6eLHdtGMeta || {},
    alias: termineraQA6eLHdtGMeta?.alias || [],
    redirect: termineraQA6eLHdtGMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/eoc/terminer.vue").then(m => m.default || m)
  },
  {
    name: identity06GHiwhdSsMeta?.name ?? "patients-patientId-record-identity",
    path: identity06GHiwhdSsMeta?.path ?? ":patientId()/record/identity",
    meta: identity06GHiwhdSsMeta || {},
    alias: identity06GHiwhdSsMeta?.alias || [],
    redirect: identity06GHiwhdSsMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/identity.vue").then(m => m.default || m)
  },
  {
    name: index8ZHe1MRNM9Meta?.name ?? "patients-patientId-record",
    path: index8ZHe1MRNM9Meta?.path ?? ":patientId()/record",
    meta: index8ZHe1MRNM9Meta || {},
    alias: index8ZHe1MRNM9Meta?.alias || [],
    redirect: index8ZHe1MRNM9Meta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/index.vue").then(m => m.default || m)
  },
  {
    name: livingPlacebtMq2Djr3WMeta?.name ?? "patients-patientId-record-livingPlace",
    path: livingPlacebtMq2Djr3WMeta?.path ?? ":patientId()/record/livingPlace",
    meta: livingPlacebtMq2Djr3WMeta || {},
    alias: livingPlacebtMq2Djr3WMeta?.alias || [],
    redirect: livingPlacebtMq2Djr3WMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/livingPlace.vue").then(m => m.default || m)
  },
  {
    name: medicalLXLHSHT6RyMeta?.name ?? "patients-patientId-record-medical",
    path: medicalLXLHSHT6RyMeta?.path ?? ":patientId()/record/medical",
    meta: medicalLXLHSHT6RyMeta || {},
    alias: medicalLXLHSHT6RyMeta?.alias || [],
    redirect: medicalLXLHSHT6RyMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/medical.vue").then(m => m.default || m)
  },
  {
    name: social8x4ArvKMcnMeta?.name ?? "patients-patientId-record-social",
    path: social8x4ArvKMcnMeta?.path ?? ":patientId()/record/social",
    meta: social8x4ArvKMcnMeta || {},
    alias: social8x4ArvKMcnMeta?.alias || [],
    redirect: social8x4ArvKMcnMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/social.vue").then(m => m.default || m)
  },
  {
    name: wayOfLife04Ec4lvMTIMeta?.name ?? "patients-patientId-record-wayOfLife",
    path: wayOfLife04Ec4lvMTIMeta?.path ?? ":patientId()/record/wayOfLife",
    meta: wayOfLife04Ec4lvMTIMeta || {},
    alias: wayOfLife04Ec4lvMTIMeta?.alias || [],
    redirect: wayOfLife04Ec4lvMTIMeta?.redirect,
    component: () => import("/app/pages/patients/[patientId]/record/wayOfLife.vue").then(m => m.default || m)
  },
  {
    name: createKPhBz5qYo3Meta?.name ?? "patients-create",
    path: createKPhBz5qYo3Meta?.path ?? "create",
    meta: createKPhBz5qYo3Meta || {},
    alias: createKPhBz5qYo3Meta?.alias || [],
    redirect: createKPhBz5qYo3Meta?.redirect,
    component: () => import("/app/pages/patients/create.vue").then(m => m.default || m)
  },
  {
    name: identitypCcICwdfytMeta?.name ?? "patients-identity",
    path: identitypCcICwdfytMeta?.path ?? "identity",
    meta: identitypCcICwdfytMeta || {},
    alias: identitypCcICwdfytMeta?.alias || [],
    redirect: identitypCcICwdfytMeta?.redirect,
    component: () => import("/app/pages/patients/identity.vue").then(m => m.default || m)
  },
  {
    name: mapNY87TP1mSOMeta?.name ?? "patients-map",
    path: mapNY87TP1mSOMeta?.path ?? "map",
    meta: mapNY87TP1mSOMeta || {},
    alias: mapNY87TP1mSOMeta?.alias || [],
    redirect: mapNY87TP1mSOMeta?.redirect,
    component: () => import("/app/pages/patients/map.vue").then(m => m.default || m)
  }
]
  },
  {
    name: practitioners8npiMKc0xeMeta?.name ?? "practitioners",
    path: practitioners8npiMKc0xeMeta?.path ?? "/practitioners",
    meta: practitioners8npiMKc0xeMeta || {},
    alias: practitioners8npiMKc0xeMeta?.alias || [],
    redirect: practitioners8npiMKc0xeMeta?.redirect,
    component: () => import("/app/pages/practitioners.vue").then(m => m.default || m),
    children: [
  {
    name: index7JpInv2z7FMeta?.name ?? "practitioners-practitionerId",
    path: index7JpInv2z7FMeta?.path ?? ":practitionerId()",
    meta: index7JpInv2z7FMeta || {},
    alias: index7JpInv2z7FMeta?.alias || [],
    redirect: index7JpInv2z7FMeta?.redirect,
    component: () => import("/app/pages/practitioners/[practitionerId]/index.vue").then(m => m.default || m)
  },
  {
    name: indexSZuZrNKLPjMeta?.name ?? "practitioners-practitionerId-planning-tasks",
    path: indexSZuZrNKLPjMeta?.path ?? ":practitionerId()/planning/tasks",
    meta: indexSZuZrNKLPjMeta || {},
    alias: indexSZuZrNKLPjMeta?.alias || [],
    redirect: indexSZuZrNKLPjMeta?.redirect,
    component: () => import("/app/pages/practitioners/[practitionerId]/planning/tasks/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91id_93i5GmLKr8rQMeta?.name ?? "report-id",
    path: _91id_93i5GmLKr8rQMeta?.path ?? "/report/:id()",
    meta: _91id_93i5GmLKr8rQMeta || {},
    alias: _91id_93i5GmLKr8rQMeta?.alias || [],
    redirect: _91id_93i5GmLKr8rQMeta?.redirect,
    component: () => import("/app/pages/report/[id].vue").then(m => m.default || m)
  },
  {
    name: reset_45password52TOS9kgCUMeta?.name ?? "reset-password",
    path: reset_45password52TOS9kgCUMeta?.path ?? "/reset-password",
    meta: reset_45password52TOS9kgCUMeta || {},
    alias: reset_45password52TOS9kgCUMeta?.alias || [],
    redirect: reset_45password52TOS9kgCUMeta?.redirect,
    component: () => import("/app/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: searchfcnTL5fl5XMeta?.name ?? "search",
    path: searchfcnTL5fl5XMeta?.path ?? "/search",
    meta: searchfcnTL5fl5XMeta || {},
    alias: searchfcnTL5fl5XMeta?.alias || [],
    redirect: searchfcnTL5fl5XMeta?.redirect,
    component: () => import("/app/pages/search.vue").then(m => m.default || m),
    children: [
  {
    name: patientsP2gYMLpH4pMeta?.name ?? "search-patients",
    path: patientsP2gYMLpH4pMeta?.path ?? "patients",
    meta: patientsP2gYMLpH4pMeta || {},
    alias: patientsP2gYMLpH4pMeta?.alias || [],
    redirect: patientsP2gYMLpH4pMeta?.redirect,
    component: () => import("/app/pages/search/patients.vue").then(m => m.default || m)
  },
  {
    name: phonebookNPXp8TLycBMeta?.name ?? "search-phonebook",
    path: phonebookNPXp8TLycBMeta?.path ?? "phonebook",
    meta: phonebookNPXp8TLycBMeta || {},
    alias: phonebookNPXp8TLycBMeta?.alias || [],
    redirect: phonebookNPXp8TLycBMeta?.redirect,
    component: () => import("/app/pages/search/phonebook.vue").then(m => m.default || m)
  },
  {
    name: practitionersTtp9lYcwoRMeta?.name ?? "search-practitioners",
    path: practitionersTtp9lYcwoRMeta?.path ?? "practitioners",
    meta: practitionersTtp9lYcwoRMeta || {},
    alias: practitionersTtp9lYcwoRMeta?.alias || [],
    redirect: practitionersTtp9lYcwoRMeta?.redirect,
    component: () => import("/app/pages/search/practitioners.vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91id_93v4tSkIo4uwMeta?.name ?? "survey-id",
    path: _91id_93v4tSkIo4uwMeta?.path ?? "/survey/:id()",
    meta: _91id_93v4tSkIo4uwMeta || {},
    alias: _91id_93v4tSkIo4uwMeta?.alias || [],
    redirect: _91id_93v4tSkIo4uwMeta?.redirect,
    component: () => import("/app/pages/survey/[id].vue").then(m => m.default || m)
  },
  {
    name: expiredKX7n0VYoDzMeta?.name ?? "survey-expired",
    path: expiredKX7n0VYoDzMeta?.path ?? "/survey/expired",
    meta: expiredKX7n0VYoDzMeta || {},
    alias: expiredKX7n0VYoDzMeta?.alias || [],
    redirect: expiredKX7n0VYoDzMeta?.redirect,
    component: () => import("/app/pages/survey/expired.vue").then(m => m.default || m)
  },
  {
    name: processPrescritionInfomo0RSFWfAPMeta?.name ?? "survey-processPrescritionInfo",
    path: processPrescritionInfomo0RSFWfAPMeta?.path ?? "/survey/processPrescritionInfo",
    meta: processPrescritionInfomo0RSFWfAPMeta || {},
    alias: processPrescritionInfomo0RSFWfAPMeta?.alias || [],
    redirect: processPrescritionInfomo0RSFWfAPMeta?.redirect,
    component: () => import("/app/pages/survey/processPrescritionInfo.ts").then(m => m.default || m)
  },
  {
    name: processSurveyAnswersHsDZDcogotMeta?.name ?? "survey-processSurveyAnswers",
    path: processSurveyAnswersHsDZDcogotMeta?.path ?? "/survey/processSurveyAnswers",
    meta: processSurveyAnswersHsDZDcogotMeta || {},
    alias: processSurveyAnswersHsDZDcogotMeta?.alias || [],
    redirect: processSurveyAnswersHsDZDcogotMeta?.redirect,
    component: () => import("/app/pages/survey/processSurveyAnswers.ts").then(m => m.default || m)
  },
  {
    name: seedSurveyAnswers1jAucYzcAGMeta?.name ?? "survey-seedSurveyAnswers",
    path: seedSurveyAnswers1jAucYzcAGMeta?.path ?? "/survey/seedSurveyAnswers",
    meta: seedSurveyAnswers1jAucYzcAGMeta || {},
    alias: seedSurveyAnswers1jAucYzcAGMeta?.alias || [],
    redirect: seedSurveyAnswers1jAucYzcAGMeta?.redirect,
    component: () => import("/app/pages/survey/seedSurveyAnswers.ts").then(m => m.default || m)
  }
]